import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const DeleteConfigTemplateModal = ({ showSignal, deleteConfigTemplateSignal, handleSubmit }) => {
    return (
        <Modal show={showSignal.value} onHide={() => showSignal.value = false}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Config Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Deleting a config template is a permanent action that cannot be reversed. </p>
                <p>Are you sure you want to delete {deleteConfigTemplateSignal.value.name}?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => showSignal.value = false}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleSubmit}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default DeleteConfigTemplateModal